module.exports = __webpack_public_path__ + "static/fonts/remixicon.888e61f0.888e61f0.ttf";